enum HomebaseTab {
    RecentlyViewed = 0,
    Searched = 1,
    Recommended = 2,
}

export default HomebaseTab;
